export enum TipoNivelAprobacion{
    Precios,
    Bonif_y_recargos
}